<template>
  <div class="ui modal" ref="modal">
    <i class="close icon"></i>
    <div class="header">
      <i class="robot icon"></i>
      {{ $t("automation task info") }}
    </div>
    <div class="image content">
      <div class="ui small image">
        <img
          src="/images/icons/automation.png"
          style="width: 100% !important"
        />
      </div>
      <div class="description" style="width: 100% !important">
        <pre>{{ task }}</pre>
      </div>
    </div>
    <div class="actions">
      <div class="ui red icon right labeled deny button">
        <i class="remove icon"></i>
        {{ $t("close") }}
      </div>
    </div>
  </div>
</template>

<script>
import { local_api, error_toast } from "@/utils";
// import CodeEditor from "@/components/code_editor/Index";

export default {
  name: "AutomationTaskInfoModalIndex",
  components: {
    // CodeEditor,
  },
  props: {},
  computed: {},
  data() {
    return {
      task: "",
    };
  },
  methods: {
    show_modal(data) {
      let vm = this;

      if (data) {
        // console.log(data);
        if (data.task_uuid) {
          local_api(vm, "post", "/automation/task/do-get", {
            u: data.task_uuid,
          })
            .then((rtask) => {
              vm.task = rtask;
              console.log("rtaskt", rtask);
            })
            .catch((err) => {
              error_toast(err);
            });
        }
      }

      window
        .jQuery(vm.$refs.modal)
        .modal({
          onVisible() {
            // Initialize calendar
            window.jQuery(vm.$refs.programmed_date_calendar).calendar({
              type: "datetime",
              today: true,
              onChange(value) {
                vm.programmed_date = value;
              },
            });
          },
          onHide() {
            vm.form.form("reset");
            vm.uuid = "";
            vm.name = "";
            vm.programmed_date = "";
            vm.group_id = "";
            vm.automator_id = "";
            vm.args = "";

            window.jQuery(vm.$refs.group_dropdown).dropdown("clear");
            window.jQuery(vm.$refs.automator_dropdown).dropdown("clear");
          },
        })
        .modal("show");

      vm.get_config();

      vm.form = window.jQuery(vm.$refs.form).form({
        fields: {
          name: ["empty"],
          programmed_date: ["empty"],
          automator: ["empty"],
        },
      });
    },
    get_config() {
      let vm = this;
      local_api(vm, "post", "/automation/configuration/do-get-task-config", {})
        .then((configuration) => {
          if (configuration && configuration.groups) {
            // Groups
            let groups_vls = configuration.groups.map((grp) => {
              return { name: grp.name, value: grp.group_id };
            });
            groups_vls.unshift({ name: vm.$t("select one"), value: "" });
            window
              .jQuery(vm.$refs.group_dropdown)
              .dropdown("setup menu", { values: groups_vls })
              .dropdown({
                onChange(value) {
                  vm.group_id = value;
                },
              });

            // Automators
            vm.automations = configuration.automators;
            let automation_vls = configuration.automators.map((grp) => {
              return { name: grp.name, value: grp.automation_id };
            });
            window
              .jQuery(vm.$refs.automator_dropdown)
              .dropdown("setup menu", { values: automation_vls })
              .dropdown({
                onChange(value) {
                  vm.automator_id = value;
                  let trgt = configuration.automators.find((grp) => {
                    return grp.automation_id == value;
                  });
                  // console.log(trgt);
                  if (trgt && trgt.group_id) {
                    window
                      .jQuery(vm.$refs.group_dropdown)
                      .dropdown("set selected", trgt.group_id);
                  }
                  if (trgt && trgt.arguments) {
                    // console.log("set arguments", trgt);
                    vm.args = trgt.arguments;
                  }
                },
              });
          }
        })
        .catch((err) => {
          error_toast(err);
        });
    },
  },
  mounted() {},
  watch: {},
  updated: function () {},
};
</script>
